export const DEFAULT_LEADERBOARD_DATA = {
    wallet: [],
    search: [],
    all: [],
};
export const ENS_REVERSE_LOOKUP = '0x3671aE578E63FdF66ad4F3E12CC0c0d71Ac7510C';
export const ADDRESSES_PER_LOOKUP = 1500;
